
import AbrirVentana from "../../reductores/acciones/widgets/AbrirVentana";
import VentanaClienteAFacturar from '../../../isp.pantalla.principal.clientes/reductores/ventanas/VentanaClienteAFacturar'
import VentanaQueryClientesAFacturar from '../../../isp.pantalla.principal.clientes/reductores/ventanas/VentanaQueryClientesAFacturar'


export default function MenuItemsClientes(dispatch) {
    return [
        
        {
            label: "Nuevo Cliente a Facturar",
            icon: "pi pi-fw pi-plus",
            command: () => {
                const nuevaVentana = new VentanaClienteAFacturar();
                dispatch(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaNuevoClienteAFacturar())
            },
        },
        {
            label: "Listar Clientes a Facturar",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryClientesAFacturar;
                dispatch(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaQueryClientesAFacturar())
            },
        },
    ];
}
